import { HttpClient } from "@angular/common/http";
import { Component, Inject, Input, OnInit } from "@angular/core";
import { UntypedFormBuilder, UntypedFormGroup } from "@angular/forms";
import { NzMessageService } from "ng-zorro-antd/message";
import { NZ_MODAL_DATA, NzModalRef, NzModalService } from "ng-zorro-antd/modal";
import * as moment from "moment";
import { formatNumber } from "@angular/common";
import { TranslateService } from "@root/shared/service/translate.service";
import { RobotRulesComponent } from "../../robot-rules/robot-rules.component";
import { EditMode } from "../../robot-rules/robot-rules.service";
import { DateService } from "@root/shared/service/date.service";
@Component({
  selector: "widget-robot-plan-edit-price",
  templateUrl: "./price.component.html",
  styleUrls: ["./price.component.scss"],
})
export class WidgetPlanEditPriceComponent implements OnInit {
  private readonly DetailApi = "/api/automation/price/plan_detail";
  private readonly EditApi = "/api/automation/price/plan_edit";
  private readonly DeleteApi = "/api/automation/price/plan_delete";
  private readonly ExecuteApi = "/api/automation/price/plan_execute_now";
  @Input() id;
  detail;
  form: UntypedFormGroup = this.fb.group({
    plan_date: null,
    plan_time: null,
    to_percent: null,
  });
  formatterPercent = (value: number): string => `${value}%`;

  get angularDateFormat() {
    return this.dateSrv.getAngularFormat(["YMD"]);
  }

  get timeFormat() {
    return this.dateSrv.getTimeFormatByField("hm");
  }

  constructor(
    private http: HttpClient,
    private fb: UntypedFormBuilder,
    private modalRef: NzModalRef,
    private modal: NzModalService,
    private msg: NzMessageService,
    private t: TranslateService,
    private dateSrv: DateService,
    @Inject(NZ_MODAL_DATA) private modalData: { id: number },
  ) {}

  ngOnInit() {
    if (this.modalData) {
      this.id = this.modalData?.id;
    }

    this.fetchDetail();
  }

  private fetchDetail() {
    const params = { plan_id: this.id };

    this.http.get(this.DetailApi, { params }).subscribe((rst: any) => {
      this.detail = rst?.data?.record;

      this.form.patchValue({
        ...this.detail,
        plan_date: moment(this.detail.plan_time).toDate(),
        plan_time: moment(this.detail.plan_time).toDate(),
        to_percent: this.detail.to_percent,
      });
    });
  }

  private requestEdit(params) {
    return this.http.post(this.EditApi, params);
  }

  private requestDelete() {
    return this.http.post(this.DeleteApi, { plan_id: this.id });
  }

  private requestExecute() {
    return this.http.post(this.ExecuteApi, { plan_id: this.id });
  }

  onSelectQuickMsg(msg) {
    this.form.patchValue({
      content: msg?.content,
    });
  }

  onRemove() {
    this.modal.confirm({
      nzTitle: this.t.t("automation-edit_task_ts_删除标题"),
      nzContent: this.t.t("automation-edit_task_ts_删除内容"),
      nzWidth: 500,
      nzOnOk: () =>
        this.requestDelete().subscribe((rst: any) => {
          if (rst.error_code === 0) {
            this.modalRef.destroy();
          }
        }),
    });
  }

  onClickEdit() {
    const modal = this.modal.create({
      nzTitle: this.t.t("robot.rule.word.create"),
      nzContent: RobotRulesComponent,
      nzWidth: 680,
      nzFooter: null,
      nzComponentParams: {
        type: "price",
        editMode: EditMode.Update,
        id: this.detail.automation_rule_id,
      },
    });

    modal.afterClose.subscribe(() => {
      // this.modalRef.destroy();
    });
  }

  onExecuteImmediately() {
    this.requestExecute().subscribe((rst: any) => {
      if (rst.error_code === 0) {
        this.msg.success(this.t.t("robot-overview_edit_ts-发送成功"));
      }
    });
  }

  onSave() {
    const value = this.form.value;
    const params = {
      plan_id: this.id,
      plan_time: moment(value.plan_date)
        .set({
          hour: moment(value.plan_time).get("hour"),
          minute: moment(value.plan_time).get("minute"),
        })
        .format("YYYY-MM-DD HH:mm:ss"),
      to_percent: value.to_percent / 100,
    };

    this.requestEdit(params).subscribe((rst: any) => {
      if (rst.error_code === 0) {
        this.modalRef.destroy();
      }
    });
    console.log("this.form.value: ", params);
  }
}
